import {types} from './types';

const initialState = {
    data: {
        list: [],
        totalPage: 1
    }
}

export function replenishmentGeneralReportReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_REPLENISHMENT_REPORT:
            return { ...state, data: action.payload};
        default:
            return state
    }
}